import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { format } from 'date-fns';
import { Eye, Copy, Trash, ArrowClockwise, CheckCircle, WarningCircle, CircleNotch } from '@phosphor-icons/react';

const ForgeManageUrls = () => {
  const [deployments, setDeployments] = useState([]);

  const fetchAll = async () => {
    try { const res = await axios.get('/api/forge/deployments', { withCredentials: true }); setDeployments(res.data); }
    catch (e) { toast.error('Failed to load'); }
  };
  useEffect(() => { fetchAll(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this site on Forge?')) return;
    try { await axios.delete(`/api/forge/deployments/${id}`, { withCredentials: true }); toast.success('Deleted'); fetchAll(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
  };

  const statusBadge = (s) => {
    if (s === 'live') return <span className="px-2 py-1 text-xs font-bold bg-[#39FF14]/10 text-[#39FF14] border border-[#39FF14]/20 flex items-center gap-1 w-fit"><CheckCircle /> live</span>;
    if (s === 'failed') return <span className="px-2 py-1 text-xs font-bold bg-red-500/10 text-red-500 border border-red-500/20 flex items-center gap-1 w-fit"><WarningCircle /> failed</span>;
    return <span className="px-2 py-1 text-xs font-bold bg-yellow-500/10 text-yellow-500 border border-yellow-500/20 flex items-center gap-1 w-fit"><CircleNotch className="animate-spin" /> {s}</span>;
  };

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-4xl font-black text-[#FB503B]">MANAGE URLs</h1>
          <p className="text-slate-400 font-mono">Your deployed on-forge.com sites.</p>
        </div>
        <button onClick={fetchAll} className="flex items-center gap-2 bg-[#0A0B0E] border border-white/20 text-white px-4 py-2 font-bold hover:bg-white/10 transition-colors"><ArrowClockwise size={18} /> Refresh</button>
      </div>

      <div className="border border-white/10 bg-card overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-white/10 bg-black/20">
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">Date</th>
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">Site</th>
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">Status</th>
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider">URL</th>
              <th className="p-4 text-xs font-bold text-slate-400 uppercase tracking-wider text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {deployments.map(dep => (
              <tr key={dep.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                <td className="p-4 text-sm text-slate-400 font-mono">{dep.created_at ? format(new Date(dep.created_at), 'yyyy-MM-dd HH:mm') : '-'}</td>
                <td className="p-4 font-mono text-sm font-bold text-white">{dep.site_name}</td>
                <td className="p-4">{statusBadge(dep.status)}</td>
                <td className="p-4 text-sm">
                  {dep.public_url ? (
                    <div className="flex items-center gap-2">
                      <div className="bg-[#0A0B0E] border border-white/10 px-2 py-1 text-xs text-slate-400 font-mono truncate w-56 select-all" title={dep.public_url}>{dep.public_url}</div>
                      <button onClick={() => { navigator.clipboard.writeText(dep.public_url); toast.success('Copied!'); }} className="text-slate-400 hover:text-white p-1"><Copy size={16} /></button>
                      <a href={dep.public_url} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-[#FB503B] p-1"><Eye size={16} /></a>
                    </div>
                  ) : dep.status === 'failed' ? <span className="text-red-500 text-xs">{dep.error_msg}</span> : '-'}
                </td>
                <td className="p-4 flex items-center justify-end">
                  <button onClick={() => handleDelete(dep.id)} className="bg-red-500/10 text-red-500 border border-red-500/20 hover:bg-red-500 hover:text-white transition-colors px-3 py-1 font-bold text-xs flex items-center gap-1 uppercase tracking-wider"><Trash size={14} /> Delete</button>
                </td>
              </tr>
            ))}
            {deployments.length === 0 && (
              <tr><td colSpan="5" className="p-8 text-center text-slate-500">No OnForge sites yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ForgeManageUrls;
